import { useEffect, useState } from 'react';

const PendingChat = () => {
	const [showMessage, setShowMessage] = useState(false);
	useEffect(() => {
		setShowMessage(false);
		  const timer = setTimeout(() => {
			setShowMessage(true);
		  }, 4000);
		  return () => clearTimeout(timer);
	  }, []);
	return (
		<div>
			{showMessage ? (
				<div className='text-sm italic mt-2'>
					Working on it, this one’s taking a bit longer than normal…
				</div>
			) : <div className='flex items-center gap-1 typing pt-3'>
				<span />
				<span />
				<span />
			</div>}
    	</div>
	)
}

export default PendingChat;